<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div class="row">
        <div class="col"></div>
        <div class="col-12 col-md-8 col-lg-6">
            <SettingsCard
                id="SpaceAccessMenuKeysCard"
                title="Keys"
                subtitle="Manage user keys"
                to="/admin/doorsnkeys/keys"
            >
            </SettingsCard>
            <SettingsCard
                id="SpaceAccessMenuPoliciesCard"
                title="Policies"
                subtitle="Configure space access policies (user groups)"
                to="/admin/doorsnkeys/policy"
            >
            </SettingsCard>

            <SettingsCard
                id="SpaceAccessMenuLocksCard"
                title="Locks"
                subtitle="Manage space locks"
                to="/admin/doorsnkeys/locks"
            >
            </SettingsCard>
        </div>
        <div class="col"></div>
    </div>
</template>

<script>
export default {
    name: 'AccessMenu',
    data() {
        return {
            space: this.$store.state.space,
        };
    },
    mounted() {},
};
</script>
